module.exports = __webpack_public_path__ + "static/media/44.f825d5cd.png";